import { render, staticRenderFns } from "./SequenceNewComponent.vue?vue&type=template&id=630b68e7&scoped=true&"
import script from "./SequenceNewComponent.vue?vue&type=script&lang=js&"
export * from "./SequenceNewComponent.vue?vue&type=script&lang=js&"
import style0 from "./SequenceNewComponent.vue?vue&type=style&index=0&id=630b68e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b68e7",
  null
  
)

export default component.exports